import { IRoute, Routes } from './route';

// menu
export const RouteMenus: IRoute[] = [
  Routes.HOME,
  Routes.THONG_TIN_CA_NHAN,
  Routes.CHAM_CONG,
  { ...Routes.NGHI_PHEP, children: [Routes.NGHI_PHEP_DON_CUA_TOI, Routes.NGHI_PHEP_PHE_DUYET] },
];
